import React, { useRef, useEffect } from 'react';
import { Field, Label, Control, Input } from "rbx";
import InputMask from 'react-input-mask';

const TextFieldMask = (props) => {
  const { name, label, mask, value, onChange, onBlur, focus=false, children, ...other } = props;
  const textField = useRef();

  useEffect(()=>{
    if (focus)
      textField.current.focus();
  },[focus]);

  return (
    <>
      {(label) && <Label className="has-text-grey">{label}</Label>}
      <Field kind="addons">
        <Control expanded >
          <InputMask mask={mask} value={value} onChange={onChange} onBlur={onBlur} maskPlaceholder={null}>
            <Input 
              type={name}
              ref={textField}
              name={name}
              {...other}
            />
          </InputMask>
        </Control>
        {children}
      </Field>
    </>
  )

}

export default TextFieldMask;
